import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function IdleDriversAvailable({ rideBookingLogicData }) {
    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 10,
            }}
        >
            <Typography
                variant="h3"
                sx={{
                    color: '#000000',
                    backgroundColor: 'rgb(249,164,9)',
                    borderRadius: 3,
                    paddingLeft: 1.5,
                    paddingRight: 1.5,
                    paddingTop: 1.0,
                    paddingBottom: 1.0,
                    fontSize: 34,
                    fontWeight: '900',
                }}
            >
                {rideBookingLogicData.bookingLogicStatus === 'IDLE_DRIVERS_AVAILABLE'
                    ? rideBookingLogicData.numIdleDrivers
                    : 0}
            </Typography>
            <Typography
                variant="h3"
                sx={{
                    ml: 1,
                    fontSize: 32,
                    fontWeight: '600',
                    color: 'white',
                }}
            >
                Available
            </Typography>
        </Box>
    );
}
